module.exports = __webpack_public_path__ + "img/abut.be3c5c93.jpg";